import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';
import { SessionStore } from '../../shared/stores/session.store';
import { ROUTE_LOGIN } from '../../shared/constants/routes';

/**
 * Protects routes that require an authenticated user.
 * When session is still loading (undefined), waits for loadSession() then allows or redirects to /login.
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const sessionStore = inject(SessionStore);
  const router = inject(Router);
  const session = sessionStore.currentSession();

  if (session !== undefined) {
    return session !== null ? true : router.createUrlTree([ROUTE_LOGIN]);
  }

  return auth.loadSession().pipe(
    take(1),
    map((s) => (s !== null ? true : router.createUrlTree([ROUTE_LOGIN]))),
  );
};
